import { render, staticRenderFns } from "./BlockedCountryDialog.vue?vue&type=template&id=ce180ac2&"
import script from "./BlockedCountryDialog.vue?vue&type=script&lang=js&"
export * from "./BlockedCountryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports